export function nativeApprovalStateMessage({ code, approved, status, error }) {
  if (!code) return { tone: "error", message: "缺少设备配对码。" };
  if (error) return { tone: "error", message: error };
  if (approved) return { tone: "success", message: "已批准。回到 Mac App 后会自动完成连接。" };
  if (status === "expired") return { tone: "error", message: "配对会话已过期，请回到 Mac App 重新发起连接。" };
  return null;
}
